// extracted by mini-css-extract-plugin
export default {"iconWrapper":"InvalidConfigWarning__iconWrapper___PEvwO"};